import styles from "./MobileAppSection.module.scss";
import useAppSelector from "../../../hooks/useAppSelector";
import appleIcon from "../../../assets/images/homepage/apple.svg";
import playMarketIcon from "../../../assets/images/homepage/play-market.svg";
import defaultImage from "../../../assets/images/homepage/default-mobile-app.png";
import {getImageUrlForContent} from "../../../helpers/image.helper";


const MobileAppSection = () => {

    const {content} = useAppSelector(state => state.siteContentSlice);

    return (
        <section className={styles.section}>
            <div className={"container"}>
                <div className={styles.wrapper}>
                    <div className={styles.item}>
                        <h2 className={styles.title}>{content.mobileAppTitle}</h2>
                        <p className={styles.description}>{content.mobileAppDescription}</p>
                        <div className={styles.linksWrapper}>
                            <a target={"_blank"} href={content.mobileAppAppStoreLink}
                               className={`${styles.linkBox} ${styles.outline}`}>
                                <img src={appleIcon} alt={"apple store"}/>
                                <div>
                                    <p>Available on</p>
                                    <h4>App Store</h4>
                                </div>
                            </a>
                            <a target={"_blank"} href={content.mobileAppGoogleLink}
                               className={`${styles.linkBox} ${styles.fill}`}>
                                <img src={playMarketIcon} alt={"play market"}/>
                                <div>
                                    <p>Available on</p>
                                    <h4>Play Store</h4>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className={styles.item}>
                        <img
                            src={getImageUrlForContent(content.mobileAppImage) ? getImageUrlForContent(content.mobileAppImage) : defaultImage}
                            className={styles.image} alt={"section"}/>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default MobileAppSection;